import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import ResetViaEmail from './components/ResetViaEmail/ResetViaEmail';
import ResetViaPhone from './components/ResetViaPhone/ResetViaPhone';
import './styles.scss';
import SnackBar from 'components/SnackBar/SnackBar';
import { useRedirectChecker } from 'hooks/useRedirectChecker';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { redirectChecker } = useRedirectChecker()

  const [selectedType, setSelectedType] = useState(null);
  const [snackbar, setSnackbar] = useState(null);

  useEffect(()=>{
    redirectChecker()
  },[])

  const backToSignIn = () => {
    navigate('/signin', {replace: true})
  };

  const onToggleRestoreMethod = () => {
    setSelectedType((prev) => (prev === 'phone' ? 'email' : 'phone'));
  };

  return (
    <section className={'auth-wrapper'}>
      <span className={'back-link'} onClick={backToSignIn}>
        {'< Back to Sign In page'}
      </span>
      <div className={'auth-block'}>
        <h2 className={'auth-title'}>3208 Technology, Inc.</h2>
        {!selectedType && (
          <div className={'auth-form'}>
            <p className={'auth-form-title'}>Forgot password</p>
            <p className={'auth-form-info'}>Set up new password with:</p>
            <button className={'auth-btn'} onClick={() => setSelectedType('phone')}>
              Phone number
            </button>
            <button className={'auth-btn'} onClick={() => setSelectedType('email')}>
              Email
            </button>
          </div>
        )}
        {selectedType === 'phone' ? (
          <ResetViaPhone
            onToggleRestoreMethod={onToggleRestoreMethod}
            selectedType={selectedType}
            setSnackbar={setSnackbar}
          />
        ) : null}
        {selectedType === 'email' ? (
          <ResetViaEmail
            onToggleRestoreMethod={onToggleRestoreMethod}
            selectedType={selectedType}
            setSnackbar={setSnackbar}
          />
        ) : null}
      </div>
      {snackbar && <SnackBar closeSnackbar={() => setSnackbar(null)} {...snackbar} isOpen={true} />}
    </section>
  );
};
export default ForgotPassword;
